export const fonts = {
  headline: "'Pacifico', Comic Sans, Comic Sans MS, cursive",
  text: "'Open Sans', sans-serif",
  subline: "'Kalam', Comic Sans, Comic Sans MS, cursive",
}
